import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import { CategoryCsvData } from "../fetchData/CategoryCsvData.js";
import { ProductCsvData } from "../fetchData/ProductCsvData.js";
import { ProductOptionsCsvData } from "../fetchData/ProductOptionsCsvData.js";
import { setSelectedCustomData2 } from "../../app/features/counter/counterSlice";
import { Margin } from "@mui/icons-material";

function TemplateA() {
  const [csvData, setCSVData] = useState([]); // Uplaod CSV state

  // CSS for table headings
  const tableStyle = {
    fontFamily: "Arial, Helvetica, sans-serif",
    borderCollapse: "collapse",
    width: "100%",
  };
  const tableHeaderStyle = {
    paddingTop: "12px",
    paddingBottom: "12px",
    paddingLeft: "10px",
    textAlign: "left",
    backgroundColor: "#212529",
    color: "white",
  };

  // Uplaod CSV Starts Here

  // const handleFileUpload = (event) => {
  //   const file = event.target.files[0];
  //   const reader = new FileReader();

  //   reader.onload = (e) => {
  //     const text = e.target.result;
  //     // const rows = text.split("\n").map((row) => row.split(","));
  //     const rows = text.split("\n").map((row) => row.split(","));
  //     setCSVData(rows);
  //   };

  //   reader.readAsText(file);
  // };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e.target.result;
      const rows = text.split("\n").map((row) => row.split(","));

      // Remove empty fields from each row
      const cleanedRows = rows.map((row) =>
        row.filter((cell) => cell.trim() !== "")
      );

      // Remove empty rows
      const nonEmptyRows = cleanedRows.filter((row) => row.length > 0);

      setCSVData(nonEmptyRows); // Update local state with cleaned CSV data
    };

    reader.readAsText(file);
  };


  // Upload CSV Ends Here

  return (
    <>
      <Container className="">
        <Row>
          <Col className="my-5">
            <div
              id="tableToConvert"
              style={{ width: "95%", backgroundColor: "", margin: "0 auto" }}
            >
              <h4 style={{ margin: "20px 0", padding: "0 10px" }}>
                Upload Items :
              </h4>

              {/* Table Started */}
              <input type="file" accept=".csv" onChange={handleFileUpload} />
              <table style={tableStyle} id="customers" className="table">
                <thead>
                  <tr>
                    {csvData.length > 0 &&
                      Object.keys(csvData[0]).map((header, index) => (
                        <th style={tableHeaderStyle} key={index}>
                          {header}
                        </th>
                      ))}
                    {/* Add the new column for the "Edit" button */}
                  </tr>
                </thead>
                <tbody>
                  {csvData.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {Object.values(row).map((cell, cellIndex) => (
                        <td key={cellIndex}>{cell}</td>
                      ))}
                      {/* Add a button in each row for the "Edit" action */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TemplateA;
